import React, { useState, useEffect, HTMLAttributes, type JSX } from 'react';
import useElementViewed from '~/lib/segment/useElementViewed';

/**
 * MonarchSection
 * This component wraps a Monarch section and auto-handles the Element Viewed event via the {@link useElementViewed} hook
 *
 * @func
 * @param {Object} props
 * @param {string} props.elementPosition - The section on the page, this value should contain the same characters as the Monarch slotId
 * @return {JSX.element}
 */
function MonarchSection({
  children,
  elementPosition,
  componentName,
}: {
  children: React.ReactElement<{
    placement?: string;
    children?: React.ReactNode;
  }>;
  elementPosition: string;
  componentName?: string;
} & HTMLAttributes<HTMLElement>): JSX.Element {
  const sectionRef = useElementViewed();
  const [fireElementViewed, setFireElementViewed] = useState(false);

  useEffect(() => {
    if (elementPosition === 'BOTTOM_STICKY_SECTION') return;

    setFireElementViewed(true);
  }, []);

  return (
    <section
      ref={fireElementViewed ? sectionRef : null}
      data-element-position={elementPosition}
      data-element-name={componentName}
      data-element-type='SLOT'
    >
      {children}
    </section>
  );
}

export default MonarchSection;
